<template>
  <section class="formCampanha mt-2">
        <validation-observer ref="campanhaRules">
            <b-form>
                <b-row>
                    <b-col lg="6" md="6" sm="12" class="pr-lg-0">
                        <b-form-group label="Nome da Campanha*" label-for="name-campanha">
                            <validation-provider
                                #default="{ errors }"
                                name="nameCampanha"
                                rules="required"
                            >
                                <b-form-input
                                    :state="errors.length > 0 || form.errors.nameCampanha ? false:null"
                                    v-mask="('X'.repeat(200))"
                                    id="name-campanha"
                                    v-model="form.nameCampanha"
                                    autocomplete="off"
                                    placeholder="Dê o nome da campanha"
                                />
                                <small v-if="errors[0]" class="text-danger d-block">
                                    Este campo é de preenchimento obrigatório.
                                </small>
                                <small v-if="form.errors.nameCampanha" class="text-danger">
                                    {{ form.errors.nameCampanha }}
                                </small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mt-1">
                    <b-col lg="5" md="6" sm="12">
                        <validation-provider
                            #default="{ errors }"
                            name="Vacina"
                            rules="required"
                        >
                            <b-form-group
                                label="Vacina*"
                                label-for="vaccines"
                                :state="errors.length > 0 || form.errors.vaccines ? false:null">
                                <v-select
                                    id="vaccines"
                                    v-model="form.vaccines"
                                    :loading="loadingVacinas"
                                    :options="vaccines"
                                    :closeOnSelect="false"
                                    multiselect
                                    multiple
                                    @input="selectedVaccines"
                                    @option:deselected="emitEventSelectedVaccines"
                                    label="nome_tecnico"
                                    placeholder="Selecione uma ou mais"
                                >
                                    <span slot="no-options">Nenhuma opção selecionável.</span>
                                </v-select>
                                <small v-if="errors[0]" class="text-danger d-block">
                                    Este campo é de preenchimento obrigatório.
                                </small>
                                <small v-if="form.errors.vaccines" class="text-danger">
                                    {{ form.errors.vaccines }}
                                </small>
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                    <b-col lg="12" md="12" sm="12" class="mt-2">
                        <validation-provider
                            #default="{ errors }"
                            name="adhesion"
                            rules="required"
                        >
                        <adhesion-no-workers-input
                        @setPartialAdhesion="setPartialAdhesion"
                        />
                        <input type="hidden" name="adhesion" :value="adhesion">
                        <small v-if="errors[0]" class="text-danger d-block">
                            Este campo é de preenchimento obrigatório.
                        </small>
                        </validation-provider>
                    </b-col>
                    <b-col lg="12" md="12" sm="12" class="mt-2">
                        <validation-provider
                            #default="{ errors }"
                            name="integracaoRnds"
                            rules="required"
                        >
                        <integracao-rnds-input @setIntegracaoRnds="setIntegracaoRnds" />
                        <input type="hidden" name="integracaoRnds" :value="integracaoRnds">
                        <small v-if="errors[0]" class="text-danger d-block">
                            Este campo é de preenchimento obrigatório.
                        </small>
                        </validation-provider>
                    </b-col>
                </b-row>
            </b-form>
        </validation-observer>
    </section>
</template>

<script>
import { BRow, BCol, BForm, BFormGroup, BFormInput,  BFormRadioGroup, BButton, BAlert } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import vSelect from 'vue-select';

import { busEvent } from '@/main';
import AdhesionNoWorkersInput from '@/views/components/custom/Inputs/AdhesionNoWorkersInput.vue';
import IntegracaoRndsInput from '@/views/components/custom/Inputs/IntegracaoRndsInput.vue';

export default {
    components: {
        BRow, BCol, BForm, BFormGroup, BFormInput, BButton, BAlert, BFormRadioGroup,
        ValidationProvider, ValidationObserver, vSelect,
        AdhesionNoWorkersInput,
        IntegracaoRndsInput,
    },

    props: {
        removedVaccina: {
            required: false,
            type: Number
        }
    },

    data() {
        return {
            required,
            saving: false,
            idCampaign: null,
            loadingVacinas: false,
            loadingDoencas: true,
            selectVaccines: true,
            adhesion: null,
            integracaoRnds: null,
            form: {
                nameCampanha: null,
                vaccines: [],
                errors: {
                    nameCampanha: null,
                    disease: null,
                    vaccines: null
                }
            },
            vaccines: []
        }
    },

    mounted() {
        this.loadVaccines();
        busEvent.$on('saveCampanha', () => {
            this.validateForm();
        });
    },

    methods: {
        validateForm() {
            this.$refs.campanhaRules.validate().then(success => {
                if (success) {
                    const ids_vacina = this.form.vaccines.map((vacina) => vacina.id_vacina);

                    const minimalDataCampaign = {
                        descricao: this.form.nameCampanha,
                        permite_adesao_parcial: this.adhesion,
                        id_doenca: this.form.disease,
                        id_vacina: ids_vacina,
                        permite_integracao_rnds: this.integracaoRnds
                    }

                    busEvent.$emit('minimalDataCampaign', minimalDataCampaign);
                }
            })
        },

        loadVaccines() {
            this.selectVaccines = true;
            this.loadingVacinas = true;

            this.form.vaccines = [];
            this.vaccines = [];

            this.emitEventSelectedVaccines();

            this.$http.get(this.$api.saveAndGetVacina(), { params: { ativo: true, paginacao: false } }).then(({ data }) => {
                this.vaccines = data.map(item => {
                    return {
                        id_vacina: item.id_vacina,
                        nome_tecnico: item.nome_tecnico_vacina,
                        hasPromotion: item.doencas.some(doenca => doenca.departamento_incentivo.length >= 2),
                        incentives: item.doencas.flatMap(doenca => doenca.departamento_incentivo.map(incentivo => {
                            return {
                                id_incentivo: incentivo.id_incentivo,
                                nome: incentivo.descricao
                            }
                        })),
                        hasPriceRange: item.tem_faixa_preco
                    }
                });

                this.selectVaccines = false;
                this.loadingVacinas = false;
            })
        },

        selectedVaccines() {
            this.emitEventSelectedVaccines();
        },

        emitEventSelectedVaccines() {
            this.$emit('selectedVaccines', {
                vaccines: this.form.vaccines
            });
        },
        setPartialAdhesion(value) {
            this.adhesion = value;
        },
        setIntegracaoRnds(value) {
            this.integracaoRnds = value;
        }
    },

    watch: {
        removedVaccina(id_vacina) {
            this.form.vaccines = this.form.vaccines.filter(vaccine => vaccine.id_vacina !== id_vacina);
            this.emitEventSelectedVaccines();
        }
    }
}
</script>
